import { FunctionComponent } from 'react';

import styles from './FormLayout.module.scss';

export type FormLayoutProps = {
  sidebar: React.JSX.Element;
  footer: React.JSX.Element;
  content: React.JSX.Element;
  backToDashboardButton: React.JSX.Element;
};

type FC = FunctionComponent<FormLayoutProps>;

const FormLayout: FC = ({ sidebar, footer, content, backToDashboardButton }: FormLayoutProps) => {
  return (
    <div className={styles.container}>
      <nav>
        {sidebar}
        <footer>{footer}</footer>
      </nav>
      <main className={styles.mainContainer}>
        {backToDashboardButton}
        {content}
      </main>
    </div>
  );
};

export default FormLayout;
